export const DEFAULT_BOARD_NAME = 'collboard';
export const TITLE_SEPARATOR = ` 🖋️ `;
export const MAX_RECURSION_LEVEL = 17;
